module.exports = __webpack_public_path__ + "cfeaf8acea967fabb942d3ac03a96d27.png";